import { render } from "./Fp.vue?vue&type=template&id=125d5b3a&scoped=true"
import script from "./Fp.vue?vue&type=script&lang=js"
export * from "./Fp.vue?vue&type=script&lang=js"

import "./Fp.vue?vue&type=style&index=0&id=125d5b3a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125d5b3a"]])

export default __exports__